@if (readonly) {
  <div class="floating-label-container">
    <div
      style="
        position: relative;
        padding: 0px 0px;
        border: 1px solid #dddddd;
        border-radius: 4px;
        background-color: #fafafa;
      "
    >
      <select
        class="floatSelect"
        [(ngModel)]="boundValue"
        [disabled]="true"
        style="background-color: #fafafa; padding: 7px 0px 7px 3px"
      >
        @for (item of options; track item) {
          <option [value]="item.id">{{ item.name }}</option>
        }
      </select>
      <div class="floatLabel" style="left: -1px">{{ label }}</div>
    </div>
  </div>
}

@if (!readonly) {
  <div [style]="style">
    <!-- [attr.data-selected-index]="selectedIndex"-->
    <div
      #container
      style="
        margin-bottom: 10px;
        margin-top: 5px;
        position: relative;
        box-sizing: border-box;
        padding: 0px 0px;
        align-items: center;
        border: 1px solid #dddddd;
        border-radius: 4px;
        background-color: #ffffff;
      "
    >
      <select
        [hidden]="multiple"
        class="floatSelect"
        style="padding: 7px 0px 7px 7px"
        id="{{ myId }}"
        #ddl
        [(ngModel)]="boundValue"
        (change)="_handle_change($event)"
        (blur)="_handle_onBlur($event)"
      >
        @for (item of options; track item) {
          <option [value]="item.id">{{ item.name }}</option>
        }
      </select>
      <select
        [hidden]="!multiple"
        multiple
        class="floatSelect"
        style="padding: 7px 0px 7px 7px"
        id="{{ myId }}"
        #ddl
        [(ngModel)]="boundValue"
        (change)="_handle_change($event)"
        (blur)="_handle_onBlur($event)"
      >
        @for (item of options; track item) {
          <option [value]="item.id">{{ item.name }}</option>
        }
      </select>
      <div [class]="label ? 'floatLabel' : ''" style="left: -1px; top: -13px">
        {{ label }}
      </div>
      @if (helpText != '') {
        <mat-icon
          class="iconOverlay"
          matTooltip="{{ helpText }}"
          [ngStyle]="{ color: '#6b7475' }"
          >info</mat-icon
        >
      }
      <!-- <div *ngIf="helpText != ''" class="helpOverlay" (mouseover)="showHelp($event);">?</div>
      <div *ngIf="helpVisible && helpText != ''" id="{{myId}}_h" (mouseout)="hideHelp($event)" (click)="$event.stopPropagation()" class="contextHelpBox">
        {{helpText}}
      </div> -->
      <label for="ddl" class="tb-validation-msg" [hidden]="isValid">{{
        validationMsg
      }}</label>
    </div>
  </div>
}
